export const UNLICENSED_USERS_TITLE = 'Unlicensed users';

export const getTableTitleFromStatus = (status: string) => {
    switch (status) {
        case '0':
            return 'Enabled users';
        case '1':
            return 'Removed users';
        case '2':
            return 'Pending users';
        case '3':
            return UNLICENSED_USERS_TITLE;
        case '4':
            return 'Unmanaged users';
        default:
            return 'Users';
    }
};

export const getEmptyStateMessageFromStatus = (status: string) => {
    switch (status) {
        case '0':
            return 'There are no enabled users';
        case '1':
            return 'There are no removed users';
        case '2':
            return 'There are no pending users';
        case '3':
            return 'There are no unlicensed users';
        case '4':
            return 'There are no unmanaged users';
        default:
            return 'No users found';
    }
};

export const getDisableAddingUserFromStatus = (status: string) => {
    return status === '1';
};
